//import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import loginRequired from "components/loginRequired";
import Login from "views/Login/Login";
import ResetPass from "views/ResetPass/ResetPass";
import Dashboard from "layouts/Dashboard/Dashboard";

const indexRoutes = [{
    path: "/login",
    component: Login,
    exact: true,
},{
    path: "/reset_pass",
    component: ResetPass,
    exact: true,
},{
    path: "/",
    component: loginRequired(Dashboard),
    exact: false,
}];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx